import React, { useState, useRef,useEffect } from "react";
import { Grid, Divider, Avatar,CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { BsFillPersonFill } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { CiCircleQuestion } from "react-icons/ci";
import { FiUpload } from "react-icons/fi";
import { BiSolidPhone } from "react-icons/bi";

import { GreenColorButton, PrimeGrayBorderColorButton, RedColorBorderButton,RedColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import SideBar from "./index";
import { OnlyDateTimeConverter,formatDateToISO } from "../../Components/Helpers/DateTimeConverter";
import LoaderModal from "../../Components/Modal/Loader"
import {GetPublicURL, PostMethod, S3Upload } from "../../Helper/api"
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomModal from "../../Components/Modal/CustomModal";
import { LogoutUser } from "../../Components/Helpers/Api";
const Profile = () => {

  const [sureName, setSureName] = useState("");
  const [lastName, setLastName] = useState("");
  const [OtherName, setOtherName] = useState("");
  const [Gender, setGender] = useState("");
  const [DOB, setDOB] = useState("");
  const [MaritalStatus, setMaritalStatus] = useState("");
  const [OtherphoneNumber, setOtherphoneNumber] = useState("");
  const [Religion, setReligion] = useState("");
  const [LanguageSpoken, setLanguageSpoken] = useState([]);
  const [OtherLanguageSpoken, setOtherLanguageSpoken] = useState("");
  const [PresentAddress, setPresentAddress] = useState("");
  const [Hobbies, setHobbies] = useState("");

  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [Addedon, setAddedon] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [ProfileImage, setProfileImage] = useState("");
  const [editProfileStatus, setEditProfileStatus] = useState(false);
  const [SuccessModal, setSuccessModal] = useState(false);
  const [ConformModal, setConformModal] = useState(false);
  const [DeleteLoader, setDeleteLoader] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false);
  const [Checked, setChecked] = useState(false);
  const [ReligionsList, setReligionsList] = useState([]);
  const fileInputRef = useRef(null);

  const handleImageUpload = async(event) => {
    const file = event.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file));
    }
    try{
      setShowLoader(true);
      let today = Date.now();
      let Extention = String(file.name).split(".");
      let name = "signatures/attachment" + today + "." + Extention[Extention.length - 1];
      let contenttype = "application/pdf";
      if (Extention[Extention.length - 1] != "pdf") {
        contenttype = "image/png";
      }
      const data = await S3Upload({ name, file, contenttype });
      setShowLoader(false)
      setImagePreview(data);
      event.target.value = "";
    }catch(Error){
      setShowLoader(false);
    }
  };
  const HandleImageRemove = () => {
    setImagePreview("");
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };
  const HandleUpdateProfile = () => {
    try {
      if (!sureName) {
        toast.warn("Enter the Sure Name");
        return;
      }
      if (!lastName) {
        toast.warn("Enter the Last Name");
        return;
      }
      if (!phoneNumber) {
        toast.warn("Enter the Phone Number");
        return;
      }
      if (!address) {
        toast.warn("Select your Base Address");
        return;
      }
      if (!state) {
        toast.warn("Enter your State");
        return;
      }
      if (!city) {
        toast.warn("Select your City");
        return;
      }
      UpdateProfile()
     
    }
    catch (err) {
      console.log("err in HandleUpdateProfile", err);
    }
  }
  const userid = localStorage.getItem("@users");
  useEffect(()=>{
    GetUsersDetails()
    GetReligion()
  },[])
  useEffect(()=>{
    GetProfileimages()
  },[imagePreview])
  const GetProfileimages=async()=>{
    const response = await GetPublicURL(imagePreview)
    setProfileImage(response)
  }
  const GetUsersDetails =async()=>{
    const userid = localStorage.getItem("@userid");
    try{
      let url="candidate/candidateDetails"
      let method ="POST"
      let params ={
        candidate_uuid:userid
      }
      setShowLoader(true)
      const response = await PostMethod({url,method,params})
      if(response.status){
        let users =response.result
        if(users.candidate_image){
          let images = users.candidate_image
          setImagePreview(images)
        }
        setSureName(users.candidate_first_name)
        setLastName(users.candidate_last_name)

        setOtherName(users.candidate_other_name)
        setGender(users.candidate_gender)
        if(users.candidate_dob){
          setDOB(formatDateToISO(Number(users.candidate_dob)))
        }
        setMaritalStatus(users.candidate_marital_status)
        setOtherphoneNumber(users.candidate_other_phonenumber)
        setReligion(users.candidate_religion)
        if(users?.candidate_language_spoken){
          setLanguageSpoken(users.candidate_language_spoken)
        }
        setOtherLanguageSpoken(users.candidate_other_language_spoken)
        setPresentAddress(users.candidate_present_address)
        setHobbies(users.candidate_hobbies)

        setEmail(users.candidate_email)
        setPhoneNumber(users.candidate_main_phonenumber)
        setState(users.candidate_state)
        setCity(users.candidate_goverment_area)
        setAddress(users.candidate_present_address)
        setAddedon(users.candidate_created_at)
        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    }catch(Error){
      setShowLoader(false)
      console.log("Error GetUsersDetails",Error)
    }
  }
  const UpdateProfile =async ()=>{
    try{
      const userida = localStorage.getItem("@userid");
      if(!userida){
        toast.warn("User authentication Failed ");
        return;
      }
      let url ="candidate/updatecandidateprofile"
      let method="PUT"
      let params={
        "candidate_uuid":userida,
        "first_name":sureName,
        "last_name":lastName,
        "mobile":phoneNumber,
        "address":address,
        "state":state,
        "city":city,
        "images":imagePreview,
        "other_name":OtherName,
        "marital_status":MaritalStatus,
        "hobbies":Hobbies,
        "present_address":PresentAddress,
        "other_phonenumber":OtherphoneNumber,
        "language_spoken":LanguageSpoken,
        "other_language":OtherLanguageSpoken,
        "religion":Religion,
      }
      const response = await PostMethod({url,method,params})
      if(response.status){
        const users = JSON.parse(userid)
        let userdata = { first_name: sureName, last_name:lastName, email: users.email,role: users.role,image:imagePreview }
        let user = JSON.stringify(userdata);
        localStorage.setItem("@users", user);
        setEditProfileStatus(false);
        toast.success("Profile Updated Successfully");
      }else{
        if(response.message){
          toast.error(response.message)
        }else{
          toast.error("Something went wrong please try again")
        }
      }
    }catch(Error){
      toast.error("Something went wrong please try again")
      console.log("err in UpdateProfile",Error)
    }
  }
  const GetReligion =async()=>{
    try{
      let url="settings/listeducation"
      let method ="POST"
      let params ={
        "type":"religions"
      }
      const response =await PostMethod({url,method,params})
      if(response.status){
        let array =[]
        response?.result?.map((item,index)=>{
          array.push({
            id: index+1,
            label: item.education_name,
            value: item.education_name
          })
        })
        setReligionsList(array)
      }
    }catch(Error){
      console.log("Something went wrong ",Error)
    }
  }
  const HandleBasicinfoCheck = (value,) => {
    const datas = [...LanguageSpoken];
    if(datas?.indexOf(value)!=-1){
      datas.splice(datas.indexOf(value),1)
    }else{
      datas.push(value)
    }
    setLanguageSpoken(datas);
  };
  const GenderInfo = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
    { value: "Separated ", label: "Separated " },
    { value: "Widowed ", label: "Widowed " },
  ];
  const GetLanguageSpoken = ()=>{
    if(LanguageSpoken){
      let str =" "
      LanguageSpoken?.map((item,i)=>{
        if(LanguageSpoken.length-1 == i){
          str += item+"."
        }else{
          str += item+","
        }
       
      })
      return str
    }else{
      return ""
    }
  }
  const DeletCandidateAccount =async()=>{
    try{
      if(!Checked){
        toast.warn("Please check the box to confirm")
        return
      }
      setDeleteLoader(true)
      const userida = localStorage.getItem("@userid");
      if(!userida){
        toast.warn("User authentication Failed ");
        return;
      }
      let url ="candidate/deleteaccount"
      let method ="PUT"
      let params ={
        "candidate_uuid":userida
      }
      const response = await PostMethod({url,method,params})
      if(response.status){
        toast.success("Your Account Deleted Successfully");
        setConformModal(false)
        setSuccessModal(true)
        setDeleteLoader(false)
      }else{
        toast.error("Something went wrong please try again")
        setDeleteLoader(false)
      }
    }catch(Error){
      setDeleteLoader(false)
      toast.error("Something went wrong please try again")
      console.log("Error",Error)
    }
  }
  const LogoutConfirmations = () => {
    LogoutUser()
  }
  return (
    <Grid item container>
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
      <Grid item container justifyContent={"space-between"} className="mt-3">
        <Grid item container lg={3} md={3} sm={12} className="bg-white p-3 borderRadius10" alignSelf={"baseline"} flexDirection={"column"} alignItems={"flex-start"}>
          <SideBar />
        </Grid>
        {editProfileStatus == false ?
          <Grid item container lg={8.8} md={8.8} sm={12} className="bg-white p-3 borderRadius10">
            <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">Your Profile</h4>
            <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <Grid item container lg={12} md={12} sm={12} xs={12} className="mt-3">
              <Grid item container lg={12} md={12} sm={12} xs={12} justifyContent={"center"} >
                <Grid item container lg={12} justifyContent={"center"}>
                  <Grid item container lg={4} overflow={"hidden"} justifyContent={"center"} alignItems={"center"}>
                    {ProfileImage ?
                      <img src={ProfileImage} style={{width: "200px", height: "200px"}} className="img-fluid" alt="ProfilePic" />
                      :
                      <Avatar alt="profilepic" sx={{ backgroundColor: "#D9D9D9", width: "100px", height: "100px" }}><BsFillPersonFill color={"#000000"} size={50} /> </Avatar>
                    }
                    
                  </Grid>
                </Grid>
                <GreenColorButton onClick={() => setEditProfileStatus(true)} className="px-3 py-2 mt-3" startIcon={<FaRegEdit color={"#ffffff"} size={24} />}>Edit Profile</GreenColorButton>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">First Name</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{sureName? sureName:"---"}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"} >
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Last Name</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{lastName? lastName:"---"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Other name</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{OtherName? OtherName:"---"}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"} >
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Gender</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{Gender? Gender:"---"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Date of Birth</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{DOB? DOB:"---"}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"} >
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Marital Status</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{MaritalStatus ? MaritalStatus :"---"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Main Phone Number</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{phoneNumber? "+234-"+phoneNumber:""}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Other Phone Number</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2"> {OtherphoneNumber? "+234-"+OtherphoneNumber:"---"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Email</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{email}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Religion</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{Religion? Religion:"---"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Languages Spoken</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{LanguageSpoken? GetLanguageSpoken() :"--"}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Other Languages Spoken</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{OtherLanguageSpoken? OtherLanguageSpoken :"--"}</p>
                  </Grid>
                </Grid>
              </Grid>
              {localStorage.getItem("@userType") === "fieldagent" || localStorage.getItem("@userType") === "fieldagentsupervisor" || localStorage.getItem("@userType") === "applicant" ?
                <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
                  <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                    <Grid item container lg={6} justifyContent={"flex-start"}>
                      <p className="poppinsMedium Text-Prime-Black text-left pb-2">State of Origin</p>
                    </Grid>
                    <Grid item container lg={6} justifyContent={"flex-start"}>
                      <p className="poppinsRegular Text-Prime-Gray text-left pb-2 text-capitalize">{state}</p>
                    </Grid>
                  </Grid>
                  <Grid item container lg={5.8} justifyContent={"space-between"} alignItems={"center"} sx={{ borderBottom: "2px dashed  #666666" }}>
                    <Grid item container lg={6} justifyContent={"flex-start"}>
                      <p className="poppinsMedium Text-Prime-Black text-left pb-2">Local Government Area</p>
                    </Grid>
                    <Grid item container lg={6} justifyContent={"flex-start"}>
                      <p className="poppinsRegular Text-Prime-Gray text-left pb-2 text-capitalize">{city}</p>
                    </Grid>
                  </Grid>
                </Grid>
                : ""}
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3" justifyContent={"space-between"} alignItems={"center"}>
               
                <Grid item container lg={5.8} justifyContent={"space-between"} sx={{ borderBottom: "2px dashed  #666666" }} alignItems={"center"}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Permanent Home Address</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{address? address:"--"}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} sx={{ borderBottom: "2px dashed  #666666" }} alignItems={"center"}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Present Residential Address</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2 text-capitalize">{PresentAddress? PresentAddress:"---"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="mt-3"  justifyContent={"space-between"} alignItems={"center"}>
                
                <Grid item container lg={5.8} justifyContent={"space-between"} sx={{ borderBottom: "2px dashed  #666666" }} alignItems={"center"}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Hobbies</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2 text-capitalize">{Hobbies? Hobbies:"---"}</p>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} justifyContent={"space-between"} sx={{ borderBottom: "2px dashed  #666666" }} alignItems={"center"}>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsMedium Text-Prime-Black text-left pb-2">Registration Date</p>
                  </Grid>
                  <Grid item container lg={6} justifyContent={"flex-start"}>
                    <p className="poppinsRegular Text-Prime-Gray text-left pb-2">{OnlyDateTimeConverter(Addedon)}</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
          :
          <Grid item container lg={8.8} md={8.8} sm={12} className="bg-white p-3 borderRadius10">
            <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">Edit Profile</h4>
            <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <Grid item container lg={12} md={12} sm={12} xs={12} className="mt-3">
              <Grid item container lg={12} md={12} sm={12} xs={12} justifyContent={"space-between"} alignItems={"center"} >
                <Grid item container lg={12} justifyContent={"center"}>
                  {ProfileImage ?
                    <Avatar sx={{ width: "100px", height: "100px" }} alt="profilepic" src={ProfileImage} />
                    : <Avatar alt="profilepic" sx={{ backgroundColor: "#D9D9D9", width: "100px", height: "100px" }}><BsFillPersonFill color={"#000000"} size={50} /></Avatar>}
                </Grid>
                <Grid item container lg={12} justifyContent={"center"} className="mt-3">
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={fileInputRef}
                    onChange={handleImageUpload}
                  />
                  <GreenColorButton onClick={handleUploadClick} className="px-3 py-2" startIcon={<FiUpload color={"#ffffff"} size={24} />}>Change Photo</GreenColorButton>
                  <RedColorBorderButton
                    className="px-3 py-2 ml-3"
                    onClick={HandleImageRemove}
                    startIcon={<RiDeleteBin6Line color={"#E62A4A"} size={24} />}
                  >
                    Remove Photo
                  </RedColorBorderButton>
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">First Name</p>
                  <CustomInput
                    // backgroundColor="#EEECEC"
                    width={"100%"}
                    height={"45px"}
                    // disabled={true}
                    textCapital={true}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholder="Enter First Name"
                    maxLength={80}
                    value={sureName}
                    onChange={(e) => setSureName(e.target.value)}
                  />

                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Last Name</p>
                  <CustomInput
                    // backgroundColor="#EEECEC"
                    width={"100%"}
                    // disabled={true}
                    height={"45px"}
                    textCapital={true}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    maxLength={80}
                    placeholder="Enter Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Other name</p>
                  <CustomInput
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    height={"45px"}
                    textCapital={true}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholder="Enter Other name"
                    maxLength={80}
                    value={OtherName}
                    onChange={(e) => setOtherName(e.target.value)}
                  />

                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Gender</p>
                  <CustomInput
                    backgroundColor="#EEECEC"
                    width={"100%"}
                    height={"45px"}
                    textCapital={true}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    maxLength={80}
                    placeholder="Enter Last Name"
                    disabled={true}
                    value={Gender}
                    onChange={(e) => setGender(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Date of Birth</p>
                  <CustomInput
                    backgroundColor="#EEECEC"
                    width={"100%"}
                    height={"45px"}
                    textCapital={true}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholder="Enter Date of Birth"
                    maxLength={80}
                    disabled={true}
                    value={DOB}
                    onChange={(e) => setDOB(e.target.value)}
                  />

                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Marital Status</p>

                  <CustomDropDown
                    placeholder={"Select Marital Status"}
                    data={GenderInfo}
                    borderRadius={"8px"}
                    backgroundColor="#FFFFFF"
                    selected={
                      MaritalStatus && {
                        label: MaritalStatus,
                        value: MaritalStatus,
                      }
                    }
                    onChange={(e) => setMaritalStatus(e.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">State of Origin</p>
                  <CustomInput backgroundColor="#EEECEC" disabled={true}  width={"100%"} height={"45px"} padding={"2.5% 3% 2.5% 0%"} border={"1px solid  #666666"} fontFamily={"PoppinsMedium"}  placeholderColor={"#666666"} placeholder="Enter Your State"   maxLength={200}  value={state} onChange={(e) => setState(e.target.value)} />
                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Local Government Area</p>
                  <CustomInput backgroundColor="#EEECEC" disabled={true} width={"100%"} height={"45px"}  padding={"2.5% 3% 2.5% 0%"} border={"1px solid  #666666"}  fontFamily={"PoppinsMedium"}   placeholderColor={"#666666"} placeholder="Enter Your City"  maxLength={200}  value={city}  onChange={(e) => setCity(e.target.value)} />
                </Grid>
              </Grid>    
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Main Phone Number</p>
                  <CustomInput
                    placeholder="Enter Contact Number"
                    // backgroundColor="#EEECEC"
                    width={"100%"}
                    // disabled={true}
                    height={"45px"}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 2%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    maxLength={10}
                    type="number"
                    value={phoneNumber}
                    InputFrontProps={<p className="Text-Prime-Black poppinsMedium pr-2" style={{wordBreak:"unset"}}>+234</p>}
                    InputProps={(<BiSolidPhone color={"#666666"} size={24} />)}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Other Phone Number</p>
                  <CustomInput
                    placeholder="Enter Contact Number"
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    height={"45px"}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 2%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    maxLength={10}
                    type="number"
                    value={OtherphoneNumber}
                    InputFrontProps={<p className="Text-Prime-Black poppinsMedium pr-2" style={{wordBreak:"unset"}} >+234</p>}
                    InputProps={(<BiSolidPhone color={"#666666"} size={24} />)}
                    onChange={(e) => setOtherphoneNumber(e.target.value)}
                  />
                </Grid>
              </Grid>
                      
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Email Address</p>
                  <CustomInput
                    placeholder="Enter Email Address"
                    disabled={true}
                    backgroundColor="#EEECEC"
                    width={"100%"}
                    height={"45px"}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    maxLength={100}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Religion</p>
                  <CustomDropDown
                    placeholder={"Select Your Religion"}
                    data={ReligionsList}
                    borderRadius={"8px"}
                    backgroundColor="#FFFFFF"
                    selected={
                      Religion && {
                        label: Religion,
                        value: Religion,
                      }
                    }
                    onChange={(e) => setReligion(e.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <Grid item container flexWrap={"wrap"}>
                    <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Languages Spoken</p>
                  </Grid>
                  <Grid item container flexWrap={"wrap"}>
                    <Grid
                      item
                      container
                      lg={4}
                      alignItems={"center"}
                    >
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={
                          LanguageSpoken?.indexOf("English") !=-1  ? true : false
                        }
                        onChange={() =>
                          HandleBasicinfoCheck("English")
                        }
                      />
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        English
                      </p>
                    </Grid>
                    <Grid
                      item
                      container
                      lg={4}
                      alignItems={"center"}
                    >
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={
                          LanguageSpoken?.indexOf("Hausa") !=-1  ? true : false
                        }
                        onChange={() =>
                          HandleBasicinfoCheck("Hausa")
                        }
                      />
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        Hausa
                      </p>
                    </Grid>
                    <Grid
                      item
                      container
                      lg={4}
                      alignItems={"center"}
                    >
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={
                          LanguageSpoken?.indexOf("Igbo") !=-1  ? true : false
                        }
                        onChange={() =>
                          HandleBasicinfoCheck("Igbo")
                        }
                      />
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        Igbo
                      </p>
                    </Grid>
                    <Grid
                      item
                      container
                      lg={4}
                      alignItems={"center"}
                    >
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={
                          LanguageSpoken?.indexOf("Yoruba") !=-1  ? true : false
                        }
                        onChange={() =>
                          HandleBasicinfoCheck("Yoruba")
                        }
                      />
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        Yoruba
                      </p>
                    </Grid>
                    <Grid
                      item
                      container
                      lg={4}
                      alignItems={"center"}
                    >
                      <CustomCheckBox
                        disableColor={"transparent"}
                        checked={
                          LanguageSpoken?.indexOf("Others") !=-1  ? true : false
                        }
                        onChange={() =>
                          HandleBasicinfoCheck("Others")
                        }
                      />
                      <p className="poppinsRegular Text-Prime-Gray text-left">
                        Others
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Other Languages Spoken</p>
                  <CustomInput
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    disabled={LanguageSpoken?.indexOf("Others") !=-1  ? false : true}
                    height={"45px"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholderColor={"#666666"}
                    placeholder="Enter Your Other Languages Spoken"
                    maxLength={200}
                    value={OtherLanguageSpoken}
                    onChange={(e) => setOtherLanguageSpoken(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Permanent Home Address</p>
                  <CustomInput
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    height={"45px"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholderColor={"#666666"}
                    placeholder="Enter Permanent Home Address"
                    maxLength={200}
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </Grid>
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Present Residential Address</p>
                  <CustomInput
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    height={"45px"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholderColor={"#666666"}
                    placeholder="Enter Present Residential Address"
                    maxLength={200}
                    value={PresentAddress}
                    onChange={(e) => setPresentAddress(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
                <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
                  <p className="Text-Prime-Black poppinsMedium pb-2 text-left">Hobbies</p>
                  <CustomInput
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    height={"45px"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    placeholderColor={"#666666"}
                    placeholder="Enter Your Hobbies"
                    maxLength={200}
                    value={Hobbies}
                    onChange={(e) => setHobbies(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Divider className="mt-4 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item container display={"flex"} justifyContent={"flex-end"} sx={{ marginTop: "3%" }}>
                <PrimeGrayBorderColorButton
                  type="submit"
                  className="px-5 py-2"
                  onClick={() => setEditProfileStatus(false)}
                >
                  Close
                </PrimeGrayBorderColorButton>
                <GreenColorButton
                  type="submit"
                  className="px-4 py-2 ml-3"
                  onClick={() => HandleUpdateProfile()}
                >
                  Save Profile
                </GreenColorButton>
              </Grid>
            </Grid>
          </Grid>
        }
      </Grid>
      <CustomModal
        open={ConformModal}
        setOpen={setConformModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "35%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#E62A4A"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Are you sure you want to delete your account? Deleting your profile will remove your application history and details from the platform, and this cannot be undone.
            </p>
            <Grid lg={12} style={{flexDirection:"row",justifyContent:"space-between",display:"flex"}}      alignItems={"center"}>
              
              <CustomCheckBox  disableColor={"transparent"} checked={Checked } onChange={() =>  setChecked(!Checked)  } />
              <p>I confirm that I want to delete my account permanently.</p>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"center"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setConformModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <RedColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => DeletCandidateAccount()}
            >
              {DeleteLoader ? <CircularProgress size="1rem" style={{ color: "#fff" }} />:"Yes"}
            </RedColorButton>
          </Grid>
        }
      />
      <CustomModal
        open={SuccessModal}
        setOpen={setSuccessModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#E62A4A"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Your Account Deleted Successfully
            </p>
          </Grid>
        }
        modalFooter={
          <Grid item container display={"flex"} justifyContent={"center"}>
            <RedColorBorderButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => LogoutConfirmations()}
            >
              ok
            </RedColorBorderButton>
          </Grid>
        }
      />
    </Grid>
  );
};
export default Profile;